<template>
  <p :class="[`${type}-message`, 'pad-0-bottom']" :data-testing="dataTesting">
    <SVGIcon v-if="type === 'info'" :path="mdiProgressAlert" />
    <SVGIcon v-else :path="mdiAlert" />
    <span v-if="isHtml" v-html="sanitizedMessage"></span>
    <span v-else>{{ message }}</span>
  </p>
</template>

<script setup lang="ts">
import { mdiAlert, mdiProgressAlert } from "@mdi/js";
import { computed } from "vue";

import { sanitizeHtml } from "@/utils/sanitize-html";

const props = defineProps({
  type: {
    default: "error",
    required: false,
    type: String,
    validator: (value: string) => {
      return ["warning", "error", "info"].includes(value);
    }
  },
  dataTesting: {
    required: false,
    type: String,
    default: ""
  },
  message: {
    required: true,
    type: String
  },
  isHtml: {
    required: false,
    default: false,
    type: Boolean
  }
});

const sanitizedMessage = computed<string>(() => sanitizeHtml(props.message));
</script>

<style scoped lang="scss">
.error-message {
  color: $danger-700;
}
.warning-message {
  color: $warn-600;
}
.info-message {
  color: $primary-600;
}
svg {
  position: relative;
  top: -1px;
  margin-right: 0.25rem;
}
</style>
